import type { Shadow } from '..';

export const shadow: Shadow = {
  center: {
    normal: '0px 2px 8px 0px rgba(0, 0, 0, 0.10)',
    emphasize: '0px 2px 8px 0px rgba(0, 0, 0, 0.20)',
  },
  left: {
    normal: '-4px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    emphasize: '-4px 4px 8px 0px rgba(0, 0, 0, 0.20)',
  },
  right: {
    normal: '4px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    emphasize: '4px 4px 8px 0px rgba(0, 0, 0, 0.20)',
  },
};
